import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import AdminPage from './Admin/AdminPage';
import CommunityPage from './Community/CommunityPage';

const normalizedPath = window.location.pathname.replace(/\/+$/, '') || '/';
const routePages = { '/k-admin': AdminPage, '/community': CommunityPage };
const CurrentPage = routePages[normalizedPath] || App;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <CurrentPage />
  </React.StrictMode>
);


